import "@shoelace-style/shoelace/dist/themes/light.css";
import "@shoelace-style/shoelace/dist/components/dialog/dialog.js";
import "@shoelace-style/shoelace/dist/components/button/button.js";
import "@shoelace-style/shoelace/dist/components/tag/tag.js";
import {
  ArrowLeft,
  ArrowRight,
  Award,
  BadgeCheck,
  BarChart2,
  Bell,
  Cake,
  Calendar,
  Camera,
  ChevronDown,
  ChevronLeft,
  CircleUser,
  Edit3,
  EllipsisVertical,
  Eye,
  EyeOff,
  Gift,
  History,
  Home,
  Info,
  Lock,
  LogOut,
  Mail,
  MessageCircle,
  Plus,
  PlusCircle,
  QrCode,
  ScanLine,
  Scissors,
  Search,
  ShieldCheck,
  Smartphone,
  Sparkles,
  Store,
  Settings2,
  Trophy,
  User,
  Users,
  WalletCards,
  X,
  Zap,
  PhoneCall,
  Send,
  MapPin,
  ExternalLink,
  Pencil,
  Trash2,
  Image,
  Languages,
  SunMoon,
  Phone,
  Clock,
  UserCheck,
  RotateCcw,
  createIcons,
} from "lucide";

const lucideIcons = {
  ArrowLeft,
  ArrowRight,
  BadgeCheck,
  BarChart2,
  Bell,
  Cake,
  Calendar,
  Camera,
  ChevronDown,
  CircleUser,
  Edit3,
  EllipsisVertical,
  Eye,
  EyeOff,
  Gift,
  History,
  Home,
  Info,
  Lock,
  LogOut,
  Mail,
  MessageCircle,
  Plus,
  QrCode,
  ScanLine,
  Scissors,
  ShieldCheck,
  Smartphone,
  Sparkles,
  Store,
  Settings2,
  Trophy,
  User,
  Users,
  WalletCards,
  X,
  Zap,
  Award,
  ChevronLeft,
  PlusCircle,
  Search,
  PhoneCall,
  Send,
  MapPin,
  ExternalLink,
  Pencil,
  Trash2,
  Image,
  Languages,
  SunMoon,
  Phone,
  Clock,
  UserCheck,
  RotateCcw,
};

export function initUI() {
  document.documentElement.classList.add("sl-theme-light");
  refreshUI();
}

export function refreshUI() {
  createIcons({
    icons: lucideIcons,
    attrs: {
      width: "20",
      height: "20",
      "stroke-width": "2",
    },
  });
}
